import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

// const routeRecord: RouteRecordRaw = {
//   name: 'client.dashboard',
//   path: '',
//   component: () => import('pages/client/Dashboard.vue'),
//   meta: {
//     roles: [Roles.Client],

//     supportedPlatforms: ['desktop', 'mobile', 'native'],
//     excludeEnv: [],
//   },
// }

const routeRecord: RouteRecordRaw = {
  name: 'client.dashboard',
  path: '',
  component: () => import('src/client/pages/Dashboard.vue'),
  meta: {
    roles: [Roles.Client],

    supportedPlatforms: ['desktop', 'mobile', 'native'],
    excludeEnv: [],
  },
}

export default routeRecord
